// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__yHEWN","houseSearch":"styles_houseSearch__zs0VV"};